(function ($, root) {
  $(document).ready(function () {
    function stickyFooterFix() {
      if ($(".search-results-body").length > 0) {
        var windowHeight = $(window).height();
        var footah = $("footer.footer");
        var footerPosition = footah.position()["top"];

        var headerHeight = $("header.header").height();
        var globalSearchBarHeight = $(".global-search-bar").height();
        var footerHeight = footah.height();
        
        if (
          $(".search-results-body").height() <
          windowHeight - footerHeight - $(".search-results-body").height()
        ) {
          footah.css("position", "absolute");
          footah.css("bottom", "0");
        } else {
          footah.css("position", "relative");
        }
      }
    }

    let locations_slider = $(".locations-slider");
    locations_slider.slick({
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:
        '<button class="prev" aria-label="previous"><span class="fas fa-chevron-left"></span><span class="sr-only">Previous</span></button>',
      nextArrow:
        '<button class="next" aria-label="next"><span class="fas fa-chevron-right"></span><span class="sr-only">Next</span></button>',
    });
    // For some reason, without this the slider goes to 0 width and doesn't reset on screen reset, so we have to so some small hack workaround here
    let hasChangedLocationsBanner = false;

    $(window).on("resize orientationChange", function (event) {
      if ($(window).width() < 1186 && !hasChangedLocationsBanner) {
        locations_slider.slick("refresh");
        hasChangedLocationsBanner = true;
      } else if ($(window).width() >= 1186) {
        hasChangedLocationsBanner = false;
      }
      stickyFooterFix();
    });


    // Sticky footer fix
    stickyFooterFix();
  });
})(jQuery, this);
